import angular from 'angular';
import '../../shared.module';
import template from './autocomplete.component.html';
import './autocomplete.component.scss';
import { nextFieldId } from '../../helpers/field-id.helper';

const SEARCH_DELAY_MS = 300;

class AutocompleteController {
  constructor($timeout) {
    this.$timeout = $timeout;
    this.text = '';
    this.open = false;
    this.activeIndex = -1;
    this.pending = null;
  }

  $onInit() {
    this.fieldId = nextFieldId();
  }

  $onChanges(changes) {
    if (changes.options) this.activeIndex = this.items.length ? 0 : -1;
    if (changes.selectedLabel && !this.open) this.text = this.selectedLabel || '';
  }

  $onDestroy() {
    if (this.pending) this.$timeout.cancel(this.pending);
  }

  get items() {
    return this.options || [];
  }

  show() {
    if (this.disabled || this.open) return;
    if (!this.open && this.selectedLabel && this.text === this.selectedLabel) this.text = '';
    this.open = true;
    this.search();
  }

  hide() {
    if (!this.open) return;
    this.open = false;
    if (this.selectedLabel) this.text = this.selectedLabel;
  }

  typed() {
    this.open = true;
    if (this.pending) this.$timeout.cancel(this.pending);
    this.pending = this.$timeout(() => this.search(), SEARCH_DELAY_MS);
  }

  search() {
    this.pending = null;
    if (this.onSearch) this.onSearch({ text: this.text || '' });
  }

  choose(option) {
    if (!option) return;
    this.open = false;
    this.text = this.keepText ? option.label : '';
    if (this.onSelect) this.onSelect({ option });
  }

  keydown(event) {
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault();
      if (!this.open) return this.show();
      const step = event.key === 'ArrowDown' ? 1 : -1;
      const count = this.items.length;
      if (count) this.activeIndex = (this.activeIndex + step + count) % count;
      return null;
    }
    if (event.key === 'Enter') {
      event.preventDefault();
      if (this.open) this.choose(this.items[this.activeIndex]);
      return null;
    }
    if (event.key === 'Escape') this.hide();
    return null;
  }
}

AutocompleteController.$inject = ['$timeout'];

angular.module('app.shared').component('cpAutocomplete', {
  bindings: {
    label: '@',
    placeholder: '@',
    icon: '@',
    error: '@',
    emptyText: '@',
    options: '<',
    selectedLabel: '<',
    keepText: '<',
    loading: '<',
    disabled: '<',
    onSearch: '&',
    onSelect: '&'
  },
  controller: AutocompleteController,
  controllerAs: 'vm',
  template
});
